<template>
  <section class="mail-card">
    <div class="mail-row"><h2>Posteingang</h2><span class="badge">{{ total }}</span></div>
    <form @submit.prevent="$emit('filter', { search, category, closed })" class="mail-stack">
      <div><label for="mail-search">Mail suchen</label><input id="mail-search" v-model="search" type="search" placeholder="Betreff, E-Mail oder Nachname" /></div>
      <div><label for="mail-category-filter">Kategorie</label><select id="mail-category-filter" v-model="category" @change="filter"><option value="">Alle Kategorien</option><option v-for="item in categories" :key="item.value" :value="item.value">{{ item.label }}</option></select></div>
      <label class="mail-check"><input v-model="closed" type="checkbox" @change="filter" />Erledigte Mails anzeigen</label>
      <button type="submit">Suchen</button>
    </form>
    <p v-if="loading" class="muted" role="status">Liste wird geladen …</p>
    <div v-if="!rows.length && !loading" class="mail-empty">Noch keine Mails. Über „Mails abgleichen“ kannst du Eingänge ab dem eingestellten Startzeitpunkt erfassen.</div>
    <ul class="mail-items">
      <li v-for="row in rows" :key="row._id"><button class="mail-item" :class="{ selected: selected === row._id }" :aria-pressed="selected === row._id" @click="$emit('select', row._id)">
        <span class="mail-row"><strong>{{ row.from.name || row.from.address }}</strong><small>{{ formatDate(row.receivedAt) }}</small></span>
        <span>{{ row.subject }}</span><span class="badge">{{ categoryLabel(row.category) }}</span>
        <small v-if="row.tac.state === 'error'">TAC-Abfrage fehlgeschlagen</small><small v-else-if="row.syncedAt">TAC-Daten vorbereitet</small><small v-else>TAC-Daten ausstehend</small>
      </button></li>
    </ul>
    <div class="mail-actions"><button :disabled="page <= 1 || loading" @click="$emit('page', page - 1)">Zurück</button><small>Seite {{ page }}</small><button :disabled="page * 40 >= total || loading" @click="$emit('page', page + 1)">Weiter</button></div>
  </section>
</template>
<script>
import { categories, categoryLabel, formatDate } from "@/api/aiMails"
export default {
  props: { rows: Array, total: Number, page: Number, loading: Boolean, selected: String },
  data: () => ({ search: "", category: "", closed: false, categories }),
  methods: { categoryLabel, formatDate, filter() { this.$emit("filter", { search: this.search, category: this.category, closed: this.closed }) } },
}
</script>
<style scoped>
.mail-items { list-style: none; margin: 1rem 0; padding: 0; display: grid; gap: .6rem; }
.ai-mails .mail-item { display: flex; flex-direction: column; align-items: flex-start; text-align: left; width: 100%; padding: .9rem; overflow-wrap: anywhere; }
.ai-mails .mail-item.selected { background: #edf5ee; border-color: #235d48; }
.mail-item .mail-row { width: 100%; gap: .4rem; }
</style>
